import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { sendEventClick } from 'src/api/tracker';

import advice from 'src/types/advice';

import Advice from 'src/components/Advice';
import SeeAllTile from 'src/components/SeeAllTile';

const AdvicesListing = ({ advices, advicesURL, categoryId, categoryPath }) => {
  const tileTitle = 'Zobacz wszystkie porady z tej kategorii';
  const tileContent = 'Zobacz wszystkie';

  return (
    <>
      {advices.map(({ title, lead, imageUrl, url }, index) => (
        <Advice
          key={title}
          imageUrl={imageUrl}
          lead={lead}
          title={title}
          url={url}
          onClick={() => {
            sendEventClick(`advices_${categoryId}_advice`, index);
          }}
        />
      ))}
      <SeeAllTile
        advicesURL={advicesURL}
        categoryPath={categoryPath}
        title={tileTitle}
      >
        {tileContent}
      </SeeAllTile>
    </>
  );
};

AdvicesListing.propTypes = {
  advices: PropTypes.arrayOf(PropTypes.shape(advice)).isRequired,
  advicesURL: PropTypes.string.isRequired,
  categoryId: PropTypes.number.isRequired,
  categoryPath: PropTypes.string.isRequired,
};

export default AdvicesListing;
